import React from 'react';

import useResourceOnboardingSequence from 'app/components/Resources/hooks/useResourceOnboardingSequence';
import useIsMobile from 'hooks/useIsMobile';

import ResourceOnboardingSequenceNext from '../ResourceOnboardingSequenceNext';
import {
  ResourceOnboardingSequenceStepCounter,
  ResourceOnboardingSequenceStepInformationContainer,
  ResourceOnboardingSequenceStepTitle,
} from '../styled';
import {
  ResourceOnboardingSequenceCalloutContainer,
  ResourceOnboardingSequenceHeartWrapper,
  ResourceOnboardingSequenceWrapper,
  ResourceOnboardingSequenceWrapperMobile,
} from './styled';

export default function ResourceOnboardingSequenceStepOne() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <ResourceOnboardingSequenceWrapperMobile>
        <ResourceOnboardingSequenceHeartWrapper />
        <ResourceOnboardingSequenceStepOneCalloutMobile />
      </ResourceOnboardingSequenceWrapperMobile>
    );
  }

  return (
    <ResourceOnboardingSequenceWrapper>
      <ResourceOnboardingSequenceStepOneCallout />
      <ResourceOnboardingSequenceHeartWrapper />
    </ResourceOnboardingSequenceWrapper>
  );
}

function ResourceOnboardingSequenceStepOneCallout() {
  const { hideLastStep } = useResourceOnboardingSequence();

  return (
    <ResourceOnboardingSequenceCalloutContainer>
      <ResourceOnboardingSequenceNext />
      <ResourceOnboardingSequenceStepInformationContainer
        style={{ maxWidth: '255px', position: 'absolute', top: '18px', left: '18px' }}
      >
        <ResourceOnboardingSequenceStepCounter>
          1/{!hideLastStep ? '3' : '2'}
        </ResourceOnboardingSequenceStepCounter>
        <ResourceOnboardingSequenceStepTitle>
          Show your appreciation to the contributor(s)
        </ResourceOnboardingSequenceStepTitle>
      </ResourceOnboardingSequenceStepInformationContainer>
      <svg
        width="316"
        height="114"
        viewBox="0 0 316 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_bd_41480_10033)">
          <mask
            id="path-1Outside-1_41480_10033"
            maskUnits="userSpaceOnUse"
            x="4"
            y="0.53125"
            width="308"
            height="105"
            fill="black"
          >
            <rect fill="white" x="4" y="0.53125" width="308" height="105" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22 2.53125C13.1634 2.53125 6 9.6947 6 18.5313V87.5312C6 96.3678 13.1634 103.531 22 103.531H277C285.837 103.531 293 96.3678 293 87.5312V61.0234L308.422 53.3123C309.896 52.5752 309.896 50.4716 308.422 49.7346L293 42.0234V18.5312C293 9.69469 285.837 2.53125 277 2.53125H22Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 2.53125C13.1634 2.53125 6 9.6947 6 18.5313V87.5312C6 96.3678 13.1634 103.531 22 103.531H277C285.837 103.531 293 96.3678 293 87.5312V61.0234L308.422 53.3123C309.896 52.5752 309.896 50.4716 308.422 49.7346L293 42.0234V18.5312C293 9.69469 285.837 2.53125 277 2.53125H22Z"
            fill="#EB823D"
            fillOpacity="0.3"
            shapeRendering="crispEdges"
          />
          <path
            d="M293 61.0234L292.106 59.2346L291 59.7874V61.0234H293ZM308.422 53.3123L309.317 55.1012V55.1011L308.422 53.3123ZM308.422 49.7346L309.317 47.9457V47.9457L308.422 49.7346ZM293 42.0234H291V43.2595L292.106 43.8123L293 42.0234ZM8 18.5313C8 10.7993 14.268 4.53125 22 4.53125V0.53125C12.0589 0.53125 4 8.59013 4 18.5313H8ZM8 87.5312V18.5313H4V87.5312H8ZM22 101.531C14.268 101.531 8 95.2632 8 87.5312H4C4 97.4724 12.0589 105.531 22 105.531V101.531ZM277 101.531H22V105.531H277V101.531ZM291 87.5312C291 95.2632 284.732 101.531 277 101.531V105.531C286.941 105.531 295 97.4724 295 87.5312H291ZM291 61.0234V87.5312H295V61.0234H291ZM293.894 62.8123L309.317 55.1012L307.528 51.5234L292.106 59.2346L293.894 62.8123ZM309.317 55.1011C312.265 53.627 312.265 49.4198 309.317 47.9457L307.528 51.5234V51.5234L309.317 55.1011ZM309.317 47.9457L293.894 40.2346L292.106 43.8123L307.528 51.5234L309.317 47.9457ZM291 18.5312V42.0234H295V18.5312H291ZM277 4.53125C284.732 4.53125 291 10.7993 291 18.5312H295C295 8.59012 286.941 0.53125 277 0.53125V4.53125ZM22 4.53125H277V0.53125H22V4.53125Z"
            fill="#FFA366"
            mask="url(#path-1Outside-1_41480_10033)"
          />
        </g>
        <defs>
          <filter
            id="filter0_bd_41480_10033"
            x="-32"
            y="-35.4688"
            width="379.528"
            height="177"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="18" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_41480_10033"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              mode="normal"
              in2="effect1_backgroundBlur_41480_10033"
              result="effect2_dropShadow_41480_10033"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_41480_10033"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </ResourceOnboardingSequenceCalloutContainer>
  );
}

function ResourceOnboardingSequenceStepOneCalloutMobile() {
  const { hideLastStep } = useResourceOnboardingSequence();

  return (
    <ResourceOnboardingSequenceCalloutContainer>
      <ResourceOnboardingSequenceNext />
      <ResourceOnboardingSequenceStepInformationContainer
        style={{ maxWidth: '185px', position: 'absolute', top: '16px', left: '37px' }}
      >
        <ResourceOnboardingSequenceStepCounter>
          1/{!hideLastStep ? '3' : '2'}
        </ResourceOnboardingSequenceStepCounter>
        <ResourceOnboardingSequenceStepTitle>
          Show your appreciation to the contributor(s)
        </ResourceOnboardingSequenceStepTitle>
      </ResourceOnboardingSequenceStepInformationContainer>
      <svg
        width="246"
        height="114"
        viewBox="0 0 246 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ zIndex: 2, position: 'relative' }}
      >
        <g filter="url(#filter0_bd_41718_10472)">
          <mask
            id="path-1Outside-1_41718_10472"
            maskUnits="userSpaceOnUse"
            x="4.4624"
            y="0.53125"
            width="238"
            height="105"
            fill="black"
          >
            <rect fill="white" x="4.4624" y="0.53125" width="238" height="105" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M39 2.53125C30.1635 2.53125 23 9.6947 23 18.5313V42.0186L7.56798 49.7346C6.09388 50.4716 6.09388 52.5752 7.56797 53.3123L23 61.0283V87.5312C23 96.3678 30.1635 103.531 39 103.531H224C232.837 103.531 240 96.3678 240 87.5312V18.5312C240 9.69469 232.837 2.53125 224 2.53125H39Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39 2.53125C30.1635 2.53125 23 9.6947 23 18.5313V42.0186L7.56798 49.7346C6.09388 50.4716 6.09388 52.5752 7.56797 53.3123L23 61.0283V87.5312C23 96.3678 30.1635 103.531 39 103.531H224C232.837 103.531 240 96.3678 240 87.5312V18.5312C240 9.69469 232.837 2.53125 224 2.53125H39Z"
            fill="#EB823D"
            fillOpacity="0.3"
            shapeRendering="crispEdges"
          />
          <path
            d="M23 42.0186L23.8945 43.8074L25 43.2546V42.0186H23ZM7.56797 53.3123L6.67354 55.1011L6.67355 55.1011L7.56797 53.3123ZM23 61.0283H25V59.7923L23.8945 59.2395L23 61.0283ZM25 18.5313C25 10.7993 31.268 4.53125 39 4.53125V0.53125C29.0589 0.53125 21 8.59013 21 18.5313H25ZM25 42.0186V18.5313H21V42.0186H25ZM8.46241 51.5234L23.8945 43.8074L22.1056 40.2297L6.67355 47.9457L8.46241 51.5234ZM8.4624 51.5234L8.46241 51.5234L6.67355 47.9457C3.72536 49.4198 3.72535 53.627 6.67354 55.1011L8.4624 51.5234ZM23.8945 59.2395L8.4624 51.5234L6.67355 55.1011L22.1056 62.8172L23.8945 59.2395ZM25 87.5312V61.0283H21V87.5312H25ZM39 101.531C31.268 101.531 25 95.2632 25 87.5312H21C21 97.4724 29.0589 105.531 39 105.531V101.531ZM224 101.531H39V105.531H224V101.531ZM238 87.5312C238 95.2632 231.732 101.531 224 101.531V105.531C233.941 105.531 242 97.4724 242 87.5312H238ZM238 18.5312V87.5312H242V18.5312H238ZM224 4.53125C231.732 4.53125 238 10.7993 238 18.5312H242C242 8.59012 233.941 0.53125 224 0.53125V4.53125ZM39 4.53125H224V0.53125H39V4.53125Z"
            fill="#FFA366"
            mask="url(#path-1Outside-1_41718_10472)"
          />
        </g>
        <defs>
          <filter
            id="filter0_bd_41718_10472"
            x="-31.5376"
            y="-35.4688"
            width="309.538"
            height="177"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="18" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_41718_10472"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              mode="normal"
              in2="effect1_backgroundBlur_41718_10472"
              result="effect2_dropShadow_41718_10472"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_41718_10472"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </ResourceOnboardingSequenceCalloutContainer>
  );
}
